const state = {};
const getters = {};
const actions = {
    //Items
    async getItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/table-purging`, {params:params})
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async deleteItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.delete(`api/table-purging`, {
                data: {
                    ids:           params.ids,
                    is_delete_all: params.is_delete_all,
                    table_name:    params.table_name
                }
            })
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },

};

const mutations = {};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
